import { render, staticRenderFns } from "./PriceSurge.vue?vue&type=template&id=50a1842c&scoped=true"
import script from "./PriceSurge.vue?vue&type=script&lang=js"
export * from "./PriceSurge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a1842c",
  null
  
)

export default component.exports